// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3wo4g","label":"Radio_label__VJPWJ","checkMark":"Radio_checkMark__vq7kz","disabled":"Radio_disabled__2FDLu"};